import * as yup from 'yup';

export const schemaAccessGroupCreate = yup.object().shape({
  description: yup.string().required('Descrição obrigatória'),
});

export const schemaAccessGroupEdit = yup.object().shape({
  description: yup.string().required('Descrição obrigatória'),
  status: yup.boolean().required('Status obrigatório'),
});
